import React from 'react';
import { useTranslation } from '../i18n';
import { getActivityImageUrl } from '../utils/helpers';

export default function StructuredDayItemCard({ item }) {
  const { t } = useTranslation();
  const title = item?.title || t('item.activity');
  const imageUrl = getActivityImageUrl(item);

  return (
    <div className="structured-item-card">
      {imageUrl && (
        <img
          src={imageUrl}
          alt={title}
          className="structured-item-card-image"
          data-export-src={imageUrl}
          onError={(event) => {
            event.currentTarget.style.display = 'none';
          }}
        />
      )}
      <div className="structured-item-card-overlay">
        <div className="structured-item-card-header">
          <h4 className="structured-item-card-title">{title}</h4>
        </div>

        {(item?.googleMapLink || item?.ticketLink) && (
          <div className="structured-item-card-links">
            {item?.googleMapLink && (
              <a
                href={item.googleMapLink}
                target="_blank"
                rel="noreferrer"
                className="structured-item-card-link"
              >
                {t('item.googleMaps')}
              </a>
            )}
            {item?.ticketLink && (
              <a
                href={item.ticketLink}
                target="_blank"
                rel="noreferrer"
                className="structured-item-card-link"
              >
                {t('item.ticket')}
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
